import {
  getTopics,
  getTopicLessons,
  findSectionNode,
  findTopicNodes,
  findTopicNode,
  getCourseExams,
  getFirstLessonInCourse,
  getFlatLessons,
  treeWalker,
} from './assemblage';

const assemblage = {
  getTopics,
  getTopicLessons,
  findSectionNode,
  findTopicNodes,
  findTopicNode,
  getCourseExams,
  getFirstLessonInCourse,
  getFlatLessons,
  treeWalker,
};

export default { assemblage };
